import { style } from "@vanilla-extract/css";

import { elevationDefinition } from "../elevations";
import type { ElevationLevel } from "../types";

export const elevations = Object.fromEntries(
  Object.entries(elevationDefinition).map(([name, rules]) => [
    name,
    style(rules),
  ]),
) as Record<ElevationLevel, string>;
